import React, { useEffect, useState } from "react";
import StepperKyc from "../../../components/StepperKyc";
import { formatString } from "../../../utils/handlers";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";
import NoDataFound from "../../../components/NoDataFound";

function OdTimeline({ id }) {
  const token = localStorage.getItem("token");

  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noDataFound, setNoDataFound] = useState(false);

  const getUserDetails = async () => {
    setNoDataFound(false);
    setLoading(true);
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users/${id}/user_timeline`,
        options
      );
      if (res.data.status === "success") {
        setTimelineData(handlePosition(res?.data?.data));
      } else {
        setTimelineData([]);
        setNoDataFound(true);
      }
    } catch (error) {
      setTimelineData([]);
      setNoDataFound(true);
    } finally {
      setLoading(false);
    }
  };

  const handlePosition = (data) => {
    return data?.map(({ name, status }, index) => {
      return {
        name: formatString(name),
        description: "",
        href: "",
        status: !status ? "" : "current",
        download: index,
        last: false,
      };
    });
  };

  useEffect(() => {
    getUserDetails();
  }, []);
  return (
    <>
      {loading && !noDataFound && (
        <div className="w-full h-[calc(100vh-280px)] flex justify-center items-center bg-white">
          <ImageLoading />
        </div>
      )}
      {!loading && noDataFound && (
        <div className="w-full h-[calc(100vh-280px)] flex justify-center items-center bg-white">
          <NoDataFound />
        </div>
      )}
      {!loading && !noDataFound && (
        <div className="border min-w-[350px] border-solid border-[#E6EBED] px-4 pt-1 py-4 rounded-lg w-fit h-full">
          <div className="mt-3 flex justify-between items-center">
            <p className=" text-base font-bold">User Timeline</p>
            {false && (
              <p className="text-sm font-semibold text-[#0069C3] cursor-pointer">
                Action Logs
              </p>
            )}
          </div>
          <div className="mt-3 h-[1px] w-full border border-solid border-[#F4F4F4]"></div>

          <div className="h-full mt-[2px]">
            <StepperKyc timeline={timelineData} />
          </div>
        </div>
      )}
    </>
  );
}

export default OdTimeline;
